module.exports = __webpack_public_path__ + "img/intro-1-hover.e08ab35f.png";